import React, { useState, useEffect } from 'react';
import styles from './styles/CredoPage.module.css';
import SmartImage from '../components/SmartImage';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { BRAND } from '../data/brand';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

/* Fotos tomadas del propio catalogo, servidas por el backend. */
const foto = (archivo: string) => `${API_URL}/uploads/catalogo/${archivo}`;

const credoItems = [
    { id: 1, image: foto('CR-0005_0.webp'), text: "Calidad que se nota en el uso diario." },
    { id: 2, image: foto('VE-T001_0.webp'), text: "Materiales nobles: acero, vidrio y porcelana." },
    { id: 3, image: foto('A-8306_0.webp'), text: "Productos pensados para durar anos." },
    { id: 4, image: foto('CR-3757_0.webp'), text: "Precios justos, sin sorpresas." },
    { id: 5, image: foto('CR-2826_0.webp'), text: "Atencion cercana, antes y despues de la compra." },
    { id: 6, image: foto('CR-1329_0.webp'), text: "Todo para tu casa, en un solo lugar." },
];

const CredoPage: React.FC = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isAnimating, setIsAnimating] = useState(false);

    const nextSlide = () => {
        if (isAnimating) return;
        setIsAnimating(true);
        setCurrentIndex((prev) => (prev === credoItems.length - 1 ? 0 : prev + 1));
    };

    const prevSlide = () => {
        if (isAnimating) return;
        setIsAnimating(true);
        setCurrentIndex((prev) => (prev === 0 ? credoItems.length - 1 : prev - 1));
    };

    // Auto-advance
    useEffect(() => {
        const timer = setInterval(() => {
            nextSlide();
        }, 5000);
        return () => clearInterval(timer);
    }, [currentIndex]);

    // Reset animation lock
    useEffect(() => {
        const timer = setTimeout(() => setIsAnimating(false), 500); // Match CSS transition
        return () => clearTimeout(timer);
    }, [currentIndex]);

    return (
        <div className={styles['credo-container']}>
            <header className={styles['credo-header']}>
                <span className={styles['credo-pretitle']}>Nuestros Principios</span>
                <h1>Nuestros compromisos</h1>
                <div className={styles['header-divider']}></div>
                <p className={styles['credo-intro']}>
                    Estos son los compromisos con los que trabajamos todos los dias.
                </p>
            </header>

            <div className={styles['carousel-wrapper']}>
                <div className={styles['carousel-content']}>

                    <div className={styles['carousel-image-container']}>
                        <SmartImage
                            src={credoItems[currentIndex].image}
                            alt={`Principio ${credoItems[currentIndex].id}`}
                            className={styles['carousel-image']}
                        />
                        <div className={styles['image-overlay']}></div>
                    </div>

                    <div className={styles['carousel-text-container']}>
                        <div className={styles['slide-number']}>0{credoItems[currentIndex].id}</div>
                        <h2 className={styles['slide-text']}>
                            "{credoItems[currentIndex].text}"
                        </h2>
                    </div>

                    <button className={`${styles['nav-btn']} ${styles['prev-btn']}`} onClick={prevSlide}>
                        <FaChevronLeft />
                    </button>
                    <button className={`${styles['nav-btn']} ${styles['next-btn']}`} onClick={nextSlide}>
                        <FaChevronRight />
                    </button>
                </div>

                <div className={styles['indicators']}>
                    {credoItems.map((_, index) => (
                        <button
                            key={index}
                            className={`${styles['indicator']} ${index === currentIndex ? styles['active'] : ''}`}
                            onClick={() => setCurrentIndex(index)}
                            aria-label={`Ir a principio ${index + 1}`}
                        />
                    ))}
                </div>
            </div>

            <div className={styles['credo-footer']}>
                <p>— {BRAND.name} —</p>
            </div>
        </div>
    );
};

export default CredoPage;